const enum PHYSICAL_ACTIVITY {
  NOT_MUCH = "Not much",
  ONE_TWO_PER_WEEK = "1-2 per week",
  THREE_FIVE_PER_WEEK = "3-5 per week",
  SIX_SEVEN_PER_WEEK = "6-7 per week",
}

export default PHYSICAL_ACTIVITY;
